module.exports = __webpack_public_path__ + "static/media/lead_generation.036dc4a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/lead_generation.svg
// module id = 396
// module chunks = 0